function n(n,r){return r.split(".").reduce(function(n,r){return null==n?void 0:n[r]},n)}function r(n,r,t){for(var u=r.split("."),e=u.pop(),i=n,o=0;o<u.length;o++){var l=u[o];l in i||(i[l]={}),i=i[l]}return e&&(i[e]=t),n}export{n as getByPath,r as setByPath};
//# sourceMappingURL=index.esm.js.map
